/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Form_FreshInputs */

const en_coach_form_fresh = /** @type {(inputs: Coach_Form_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prime State. Ready to Race.`)
};

const de_coach_form_fresh = /** @type {(inputs: Coach_Form_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topform. Bereit für den Wettkampf.`)
};

/**
* | output |
* | --- |
* | "Prime State. Ready to Race." |
*
* @param {Coach_Form_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_form_fresh = /** @type {((inputs?: Coach_Form_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Form_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_form_fresh(inputs)
	return de_coach_form_fresh(inputs)
});